export enum EMeasurementStatus {
    NOT_STARTED = "NOT_STARTED",
    WAIT = "WAIT",
    INIT = "INIT",
    INIT_DOWN = "INIT_DOWN",
    PING = "PING",
    DOWN = "DOWN",
    UP = "UP",
    INIT_UP = "INIT_UP",
    SPEEDTEST_END = "SPEEDTEST_END",
    QOS_TEST_RUNNING = "QOS_TEST_RUNNING",
    QOS_END = "QOS_END",
    SUBMITTING_RESULTS = "SUBMITTING_RESULTS",
    END = "END",
    ERROR = "ERROR",
    ABORTED = "ABORTED",
    PACKET_LOSS_AND_JITTER = "PACKET_LOSS_AND_JITTER",
    SHOWING_RESULTS = "SHOWING_RESULTS",
}
